<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg" style="min-height: 250px">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("ResetPass")}}</h4>
                  <p style="margin-top: 70px" v-if="buttonDisabled">{{$t("PasswordReset")}}</p>
                </div>

                <p v-if="!buttonDisabled" style="margin-top: 50px" >{{$t("NewPass")}}</p>
                <vs-input icon-no-border icon-pack="feather" type="password" icon="icon-lock" v-if="!buttonDisabled" v-model="newPass" class="w-full" />

                <div style="margin-top: 50px">
                  <vs-button :disabled="buttonDisabled" @click="resetPass" >{{$t("ResetPass")}}</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      buttonDisabled: false,
      newPass: '',
    }
  },
  methods: {
    resetPass() {
      this.$vs.loading();
      const thisIns = this;
      this.$http.post('/api/v1/resetPass/' + this.$route.params.id, {
        password: this.newPass
      }).then(function () {
        thisIns.buttonDisabled = true;
        thisIns.$vs.loading.close();
        setTimeout(function () {
          thisIns.$router.push('/login')
        }, 3000)
      }).catch(function () {
        thisIns.$vs.loading.close();
        thisIns.$vs.notify({
          title:'Error',
          text: "Failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });
    }
  }
}
</script>

<style lang="scss">
</style>
